import { IStormDoorColorOption } from "../entities-generated/common/storm-door-color-option";
import { IProjectConfiguration } from "../entities-generated/models/project/project-configuration";
import { IUpdateStormDoorColorPreferenceRequest } from "../entities-generated/models/storm-door/update-storm-door-color-preference-request";
import { ApiClient } from "./shop-api-client";

class ColorApiClientClass {
  public getStormDoorColors() {
    return ApiClient.get<IStormDoorColorOption[]>('shop/storm-doors/colors');
  }

  public setStormDoorColorPreferences(request: IUpdateStormDoorColorPreferenceRequest) {
    return ApiClient.post<void>('shop/storm-doors/prefs/color', request);
  }

  public updateStormDoorColorPreferences(request: IUpdateStormDoorColorPreferenceRequest) {
    return ApiClient.put<IProjectConfiguration>('shop/storm-doors/prefs/color', request);
  }
}

export const ColorApiClient = new ColorApiClientClass();